import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { ModalContainerComponent } from '../../../../components/modals/modal-container.component';
import { ModalService } from '../../../../services/modal.service';
import { IModal } from '../../../../components/modals/modal.interface';
import { ITenant } from '../../../../../../shared/interfaces/tenant.interface';
import { alertType } from '../../../../constants/alert.constants';

enum State {
  loading = 'loading',
  success = 'success',
  error = 'error',
  info = 'info',
}

@Component({
  selector: 'app-migration-troubleshoot-modal',
  templateUrl: './migration-troubleshoot-modal.component.html',
  styleUrls: ['./migration-troubleshoot-modal.component.scss'],
  standalone: false,
})
export class MigrationTroubleshootModalComponent implements IModal, OnDestroy {
  private subscription: Subscription;
  public State: typeof State = State;
  public state: State;
  public alertType: typeof alertType = alertType;

  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;

  @Input()
  public tenant: ITenant;

  constructor(private modalService: ModalService) {
    this.subscription = new Subscription();
    this.state = State.info;
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public close(): void {
    this.modalService.closeModal();
  }

  public startLoading(): void {
    this.state = State.loading;
  }

  public get isLoading(): boolean {
    return this.state === State.loading;
  }

  public resync(): void {
    // EAP-22402 not implemented
    // resync is an old security feature so it's removed apart of old security cleanup
    this.state = State.error;
  }
}
